import script from "./MessageBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageBoard.vue?vue&type=script&setup=true&lang=js"

import "./MessageBoard.vue?vue&type=style&index=0&id=adb2e6e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adb2e6e0"]])

export default __exports__